import { render, staticRenderFns } from "./TextDetails.vue?vue&type=template&id=3ae2f6cf&scoped=true"
import script from "./TextDetails.vue?vue&type=script&lang=js"
export * from "./TextDetails.vue?vue&type=script&lang=js"
import style0 from "./TextDetails.vue?vue&type=style&index=0&id=3ae2f6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2f6cf",
  null
  
)

export default component.exports